import React, { useState } from "react";
import {Card, Upload, message, Select } from "antd";
import * as pdfjsLib from "pdfjs-dist";
import "pdfjs-dist/build/pdf.worker.entry";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { useTranslation } from "react-i18next";
import StandardButton from "../components/StandardButton";

const PdfToImage = () => {
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfPreviewUrl, setPdfPreviewUrl] = useState(null);
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const { t } = useTranslation();

  const beforeUpload = async (file) => {
    if (file.type !== "application/pdf") {
      message.error(t("only_pdf_supported"));
      return false;
    }

    const previewURL = URL.createObjectURL(file);
    setPdfFile(file);
    setPdfPreviewUrl(previewURL);

    const reader = new FileReader();
    reader.onload = async () => {
      const typedArray = new Uint8Array(reader.result);
      const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;
      setTotalPages(pdf.numPages);
      setPage(1);
    };
    reader.readAsArrayBuffer(file);

    return false;
  };

  const handleDownloadImage = async () => {
    if (!pdfFile || !page) return;
    setLoading(true);

    const reader = new FileReader();
    reader.onload = async () => {
      const typedArray = new Uint8Array(reader.result);
      const pdf = await pdfjsLib.getDocument({ data: typedArray }).promise;
      const pdfPage = await pdf.getPage(page);

      const viewport = pdfPage.getViewport({ scale: 2 });
      const canvas = document.createElement("canvas");
      const context = canvas.getContext("2d");
      canvas.width = viewport.width;
      canvas.height = viewport.height;

      await pdfPage.render({ canvasContext: context, viewport }).promise;
      const dataUrl = canvas.toDataURL("image/png");

      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `page-${page}.png`;
      link.click();

      setLoading(false);
    };
    reader.readAsArrayBuffer(pdfFile);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-0">
      <Header />
      <div className="max-w-5xl mx-auto">
        <Card className="p-6 rounded-xl shadow-lg space-y-6">
          {!pdfFile && (
            <div className="min-h-[70vh] flex items-center justify-center">
              <Upload beforeUpload={beforeUpload} showUploadList={false} accept=".pdf">
                <StandardButton size="large" type="secondary">
                  {t("upload_pdf_simple")}
                </StandardButton>
              </Upload>
            </div>
          )}

          {pdfPreviewUrl && (
            <>
              <iframe
                src={pdfPreviewUrl}
                title="PDF Preview"
                className="w-full h-[800px] border rounded shadow"
              />
              <div className="mt-4 flex flex-col md:flex-row md:items-center gap-4">
                <Select
                  className="w-full md:w-1/3"
                  value={page}
                  onChange={(value) => setPage(value)}
                  placeholder={t("select_page_placeholder")}
                >
                  {Array.from({ length: totalPages }, (_, idx) => (
                    <Select.Option key={idx + 1} value={idx + 1}>
                      {t("page_label")} {idx + 1}
                    </Select.Option>
                  ))}
                </Select>
                <StandardButton onClick={handleDownloadImage} disabled={loading} type="secondary" loading={loading}>
                  {loading ? t("processing") : t("download_image_button")}
                </StandardButton>
              </div>
            </>
          )}
        </Card>
        <Footer />
      </div>
    </div>
  );
};

export default PdfToImage;